import { render, staticRenderFns } from "./policyDetail.vue?vue&type=template&id=cc40c526&scoped=true&"
import script from "./policyDetail.vue?vue&type=script&lang=js&"
export * from "./policyDetail.vue?vue&type=script&lang=js&"
import style0 from "./policyDetail.vue?vue&type=style&index=0&id=cc40c526&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc40c526",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc40c526')) {
      api.createRecord('cc40c526', component.options)
    } else {
      api.reload('cc40c526', component.options)
    }
    module.hot.accept("./policyDetail.vue?vue&type=template&id=cc40c526&scoped=true&", function () {
      api.rerender('cc40c526', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/tenants/policyDetail.vue"
export default component.exports